export const togglePassword = () => {
  const passwordElements = document.querySelectorAll('[type="password"]:not([data-init="true"])')

  for (const element of passwordElements) {
    const wrapper = element.closest('.fui-input-wrapper')

    if (!wrapper) {
      return
    }

    const div = document.createElement('div')
    div.classList.add('password')
    div.classList.add('password_hidden')

    div.addEventListener('click', (e: MouseEvent): void => {
      const target: HTMLElement = e.target as HTMLElement
      const passwordElement: HTMLInputElement | null = target.previousSibling as HTMLInputElement

      if (!passwordElement) {
        return
      }

      if (passwordElement.getAttribute('type') === 'password') {
        passwordElement.setAttribute('type', 'text')
        target.classList.toggle('password_shown')
        target.classList.toggle('password_hidden')

        return
      }

      passwordElement.setAttribute('type', 'password')
      target.classList.toggle('password_shown')
      target.classList.toggle('password_hidden')
    })

    wrapper.appendChild(div)
    element.setAttribute('data-init', 'true')
  }
}
